import {downloadFileAPI} from '../../../utils';
import {BASE_URL} from '../../../utils/endpoints';
import {Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

interface ContractPdfDownloadButtonProps {
  contractId?: number;
  status?: string;
  label?: string;
  fileName?: string;
  className?: string;
  isZip?: boolean;
}

const DOWNLOADABLE_STATUSES = ['pending', 'negotiate', 'accepted', 'completed'];

export const ContractPdfDownloadButton = ({
                                            contractId,
                                            status,
                                            label,
                                            fileName = 'contract',
                                            className = 'btn-outline-primary',
                                            isZip = false,
                                          }: ContractPdfDownloadButtonProps) => {
  const {t} = useTranslation();

  if (!contractId || !DOWNLOADABLE_STATUSES.includes(status ?? '')) {
    return null;
  }

  const handleDownload = () => {
    const url = isZip
      ? `${BASE_URL}admin/offers/pdf/${contractId}/contract/zip`
      : `${BASE_URL}admin/offers/pdf/${contractId}/pdf/contract`;

    downloadFileAPI(url, undefined, fileName);
  };

  return (
    <Button onClick={handleDownload} className={className}>
      {label ?? t('general.download')}
    </Button>
  );
};
